import { Avatar, Box, Divider, Link, Typography } from '@mui/material';
import { paletteV2 } from '@zaplify/ui';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Link as RouterLink } from 'react-router-dom';
import { useAppSelector } from '../../../redux/store/configureStore';
import { paths } from '../../../routes/paths';
import { AccountManagementViews } from '../constants';

const AccountManagementSideBar = () => {
    const companyName = useAppSelector((state) => state.user.zaplifyUser.userOrganization?.name || '');
    const pathSegments = window.location.pathname.split('/');
    const lastPathSegment = pathSegments.pop() || pathSegments.pop();

    return (
        <SideContainer>
            <Box
                sx={{
                    display: 'flex',
                    gap: '12px',
                    flexDirection: 'column',
                }}
            >
                <Typography
                    sx={{
                        fontSize: 14,
                        color: paletteV2.neutrals.deepGrey,
                        lineHeight: '21px',
                    }}
                >
                    Organization settings
                </Typography>
                <MenuItem
                    dataCy="user-organization-settings-button"
                    text="Organization"
                    link={paths.ACCOUNT_MANAGEMENT + '/' + AccountManagementViews.ORGANIZATION_SETTINGS}
                    isActive={lastPathSegment === AccountManagementViews.ORGANIZATION_SETTINGS}
                />
                <Divider sx={{ pt: '16px', mb: '16px' }} />
                {/* <MenuItem
                    dataCy="outreach-accounts-button"
                    text="Outreach Accounts"
                    link={paths.ACCOUNT_MANAGEMENT + '/' + AccountManagementViews.OUTREACH_ACCOUNTS}
                    isActive={lastPathSegment === AccountManagementViews.OUTREACH_ACCOUNTS}
                /> */}
            </Box>
        </SideContainer>
    );
};

const SideContainer = ({ children }: { children: React.ReactNode }) => (
    <Box
        sx={{
            boxSizing: 'border-box',
            background: '#FFFFFF',
            border: '1px solid #E4E6EB',
            boxShadow: '0px 2px 7px rgba(112, 144, 176, 0.14)',
            borderRadius: '14px',
            width: 320,
            minWidth: 320,
            height: 500,
            padding: '24px',
        }}
    >
        {children}
    </Box>
);

const MenuItem = ({ text, link, isActive, dataCy }: { text: string; link: string; isActive: boolean; dataCy }) => (
    <RouterLink data-cy={dataCy} to={link} style={{ textDecoration: 'none' }}>
        <Link
            sx={{
                fontSize: 17,
                fontWeight: 500,
                lineHeight: '24px',
                color: isActive ? paletteV2.primary.base : paletteV2.subline,
                textDecoration: 'none',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
        >
            {text}
            {isActive ? <ChevronLeft /> : <ChevronRight />}
        </Link>
    </RouterLink>
);

const CompanyInfoWithAvatar = ({ companyName, users }: { companyName: string; users: number }) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            paddingBottom: '6px',
        }}
    >
        <Avatar
            sx={{
                width: 48,
                height: 48,
                bgcolor: paletteV2.primary.light,
                color: paletteV2.primary.medium,
                fontSize: '19px',
                fontWeight: 500,
                lineHeight: '28px',
            }}
        >
            {companyName.charAt(0)}
        </Avatar>
        <Box>
            <Typography
                sx={{
                    color: paletteV2.black,
                    fontWeight: 500,
                    fontSize: 19,
                    lineHeight: '28px',
                }}
            >
                {companyName}
            </Typography>
            <Typography
                sx={{
                    color: paletteV2.grey['4'],
                    fontSize: 14,
                    lineHeight: '21px',
                }}
            >
                {users} team {users === 1 ? 'member' : 'members'}
            </Typography>
        </Box>
    </Box>
);

export default AccountManagementSideBar;
